import { SuggestionSelect, SuggestionType } from '../components/suggestion-select';
import { getData } from '../utils/ajax-utils';

export function initPlfeForm(): void {
    document.querySelectorAll<HTMLFormElement>('.js-plfe-form').forEach($form => {
        new PlfeForm($form);
    });
}

/**
 * Formulaire PLFE - Affiche des suggestions de remplissage pour les :
 * - Régions sur les inputs qui ont la classe `js-plfe-region`
 * - Départements sur les inputs qui ont la classe `js-plfe-departement`
 * - Communes sur les inputs qui ont la classe `js-plfe-commune`
 */
class PlfeForm {
    $form: HTMLFormElement;
    $regionsInput: HTMLInputElement[];
    $departementsInput: HTMLInputElement[];
    $communesInput: HTMLInputElement[];

    constructor ($form: HTMLFormElement) {
        this.$form = $form;
        this.$regionsInput = Array.from($form.querySelectorAll<HTMLInputElement>('.js-plfe-region'));
        this.$departementsInput = Array.from($form.querySelectorAll<HTMLInputElement>('.js-plfe-departement'));
        this.$communesInput = Array.from($form.querySelectorAll<HTMLInputElement>('.js-plfe-commune'));

        this.$regionsInput.forEach($regionInput => {
            new SuggestionSelect($regionInput, {
                dataset: this.getRegions(),
                nbResultsToShow: 10,
                nbCharBeforeSearch: 0,
            });
        });

        this.$departementsInput.forEach($departementInput => {
            new SuggestionSelect($departementInput, {
                dataset: this.getDepartements(),
                nbResultsToShow: 10,
                nbCharBeforeSearch: 0,
            });
        });

        this.$communesInput.forEach($communeInput => {
            new SuggestionSelect($communeInput, {
                dataset: this.searchCommune.bind(this),
                useCache: true,
                nbResultsToShow: 10,
            });
        });
    }

    async getRegions(): Promise<SuggestionType[]> {
        return await getData('https://geo.api.gouv.fr/regions', {
            fields: 'nom',
            format: 'json',
        }).then((results: { nom: string }[]) => {
            return results.map(result => {
                return {
                    label: result.nom,
                    value: result.nom,
                };
            });
        });
    }

    async getDepartements(): Promise<SuggestionType[]> {
        return await getData('https://geo.api.gouv.fr/departements', {
            fields: 'nom,code',
            format: 'json',
        }).then((results: { nom: string, code: string }[]) => {
            return results.map(result => {
                return {
                    label: `${result.nom} (${result.code})`,
                    value: result.nom,
                };
            });
        });
    }

    async searchCommune(search: string, abortSignal: AbortSignal|undefined): Promise<SuggestionType[]> {
        return await getData('https://geo.api.gouv.fr/communes', {
            nom: search,
            fields: 'nom,codesPostaux',
            format: 'json',
        }, abortSignal).then((results: { nom: string, codesPostaux: string[] }[]) => {
            return results.map(result => {
                return {
                    label: `${result.nom} (${result.codesPostaux.join(' ')})`,
                    value: result.nom,
                };
            });
        });
    }
}